module.exports = __webpack_public_path__ + "25b6a0249c4cdc9e1444332f126e6ee1.svg";